<nz-skeleton *ngIf="!userProfile" [nzActive]="true"></nz-skeleton>

<div *ngIf="userProfile">
    <div class="relative flex-start-center gap-x-4">
        <app-hexagon-img [imgUrl]="userService.userAvatar" class="w-[96px] min-w-[96px]"></app-hexagon-img>

        <div class="flex-1 min-w-0 space-y-2">
            <!-- Address Display Logic -->
            <div class="w-full space-y-1.5">
                <div
                    *ngIf="!userProfile.ens_name && !userProfile.display_name; else onlyENS"
                    class="w-full flex-start-center gap-x-2"
                    appCopy
                    [copyText]="userProfile.wallet_address"
                >
                    <div class="w-[calc(100%-36px)] text-xl font-semibold truncate max-w-fit">{{ userProfile.wallet_address | address }}</div>
                    <button nz-button class="icon-btn" nzSize="small">
                        <span nz-icon nzType="antd:v2-copy" class="text-base"></span>
                    </button>
                </div>

                <ng-template #onlyENS>
                    <ng-container *ngIf="userProfile.ens_name && !userProfile.display_name;else default">
                        <div class="w-full text-xl font-normal min-w-0 max-w-full inline-block truncate align-middle">
                            {{ userProfile.ens_name }}
                            <img src="/assets/imgs/ens.png" class="w-6 inline-block ml-2" />
                        </div>

                        <div class="w-full flex-start-center gap-x-2" appCopy [copyText]="userProfile.wallet_address">
                            <div class="w-[calc(100%-36px)] text-sm truncate max-w-fit">{{ userProfile.wallet_address | address }}</div>
                            <button nz-button class="icon-btn" nzSize="small">
                                <span nz-icon nzType="antd:v2-copy" class="text-base"></span>
                            </button>
                        </div>
                    </ng-container>
                </ng-template>

                <ng-template #default>
                    <div class="text-xl font-semibold max-w-full min-w-0 truncate">{{ userProfile.display_name }}</div>

                    <div *ngIf="!userService.isOnlyTg" class="flex-start-center">
                        <div *ngIf="userProfile.ens_name" class="text-sm text-black text-opacity-80 flex justify-start items-center gap-x-1">
                            <div class="flex-1 min-w-0 truncate">{{ userProfile.ens_name }}</div>

                            <img class="w-4 h-4 inline-block" src="/assets/imgs/ens.png" alt="" />
                        </div>

                        <div *ngIf="userProfile.ens_name" class="divider-vertical h-4 mx-2"></div>

                        <div class="flex-1 min-w-0 flex-start-center gap-x-2" appCopy [copyText]="userProfile.wallet_address">
                            <div class="w-[calc(100%-36px)] text-sm truncate max-w-fit">{{ userProfile.wallet_address | address }}</div>
                            <button nz-button class="icon-btn" nzSize="small">
                                <span nz-icon nzType="antd:v2-copy" class="text-base"></span>
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div class="w-full flex-start-center gap-x-2.5">
                <a
                    *ngIf="userProfile.twitter_username && !userProfile.hide_twitter"
                    [href]="'https://x.com/' + userProfile.twitter_username"
                    [nz-tooltip]="userProfile.twitter_username"
                    target="_blank"
                    nz-button
                    class="icon-btn"
                    nzSize="small"
                >
                    <span nz-icon nzType="antd:x" class="text-base"></span>
                </a>

                <ng-container *ngIf="isMe">
                    <button
                        *ngIf="!userProfile.telegram_username"
                        nz-button
                        class="icon-btn"
                        nzSize="small"
                        [routerLink]="['/','my-profile','edit']"
                        [ngClass]="{
                            '!border !border-black !bg-white': !userProfile.telegram_username
                        }"
                    >
                        <span nz-icon nzType="antd:telegram" class="text-base"></span>
                    </button>

                    <button nz-button class="icon-btn !border !border-black !bg-white" nzSize="small" [routerLink]="['/','my-profile','edit']">
                        <span nz-icon nzType="antd:v2-edit" class="text-base"></span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="flex-start-center mt-3 text-xs">
        <a [routerLink]="followersLink" class="flex-start-center gap-x-1.5">
            <div class="text-sub-text">{{'Follower' | pluralize : userProfile?.followers_count }}</div>
            <div class="font-semibold">{{ userProfile?.followers_count | kmb2:2 }}</div>
        </a>

        <div class="divider-vertical h-3 mx-4"></div>

        <a [routerLink]="followingsLink" class="flex-start-center gap-x-1.5">
            <div class="text-sub-text">{{'Following'}}</div>
            <div class="font-semibold">{{ userProfile?.followings_count | kmb2:2 }}</div>
        </a>
    </div>

    <div class="h-[70px] w-auto relative mt-3">
        <img *ngIf="isMe" src="/assets/imgs/logo/socialscan-bg.png" class="w-auto h-full absolute top-0 left-0" alt="" />
        <div class="flex justify-center items-start h-full flex-col relative z-10">
            <div class="flex-end-center gap-x-1">
                <div class="text-sub-text text-xs">Networth</div>
                <span *ngIf="!fetchingData && !userService.isOnlyTg" nz-icon nzType="antd:v2-refresh" class="text-sm text-black" (click)="sync()"></span>
                <span *ngIf="fetchingData" nz-icon nzType="loading" nzTheme="outline" class="text-sm text-black"></span>
            </div>

            <div class="font-semibold text-[30px]">${{myAssetsInfo.netWorth | kmb2:2}}</div>
        </div>
    </div>

    <div class="flex-between-stretch gap-x-4 mt-3">
        <div class="bg-badge flex-1 rounded-lg flex-start-center text-xs px-3 py-1.5">
            <div class="flex-1 min-w-0">
                <div class="flex-start-center gap-x-1">
                    <img src="/assets/imgs/hemera-black.png" class="w-3 h-3" alt="" />
                    <div class="text-sub-text font-light">$DAY</div>
                </div>
                <div class="font-semibold mt-1">{{currentAvailableMiningTimes | number:'1.0-6'}}</div>
            </div>

            <div class="divider-vertical h-6 mx-4"></div>

            <div class="flex-1 min-w-0">
                <div class="flex-start-center gap-x-1">
                    <div class="w-3 h-3 rounded-full bg-black flex-center-center">
                        <img src="/assets/imgs/icon/sun-v2.png" class="w-2 h-2" alt="" />
                    </div>
                    <div class="text-sub-text font-light">Points</div>
                </div>
                <div class="font-semibold mt-1">{{ (myProfile?.points || 0) | kmb2:2 }}</div>
            </div>
        </div>
        <app-follow-btn *ngIf="!isMe" theme="dark" [followedWalletAddressInfo]="walletProfile" size="large"></app-follow-btn>

        <button
            *ngIf="isMe"
            nz-button
            nzSize="large"
            class="!bg-gradient w-fit !border-none !text-xs !font-semibold"
            (click)="openCheckInModal()"
            [@tada]="checkInAnimationState"
        >
            <span>Daily Check-in</span>
        </button>
    </div>
</div>
